import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/like/importer/likeImporterActions'

export default importerReducers(actions)
